"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressWrapper = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _AddressInfo = require("./AddressInfo");
var _EditButton = require("./EditButton");
var _ShippingOfferTooltip = require("./ShippingOfferTooltip");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
  alignItems: 'start',
  display: 'flex',
  position: 'relative'
});
const ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
  borderRadius: '50%',
  display: 'flex',
  height: 45,
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  position: 'relative',
  width: 45,
  minHeight: 45,
  minWidth: 45
}));
const ShippingFeeInfo = (0, _mui.styled)('div')({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto'
});
const ShippingFeeWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingLeft: theme.spacing(2),
  textAlign: 'right'
}));
const ShippingFee = (0, _mui.styled)(_mui.Typography)({
  fontWeight: 'bold'
});
const OriginalShippingFee = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textDecoration: 'line-through',
  color: theme.palette.grey.A700
}));
const getDeliveryIcon = deliveryMethodType => {
  switch (deliveryMethodType) {
    case _models.AddressItemDeliveryMethod.DepartmentStore:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Box, {});
    case _models.AddressItemDeliveryMethod.Home:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Home, {});
    case _models.AddressItemDeliveryMethod.PostOffice:
    case _models.AddressItemDeliveryMethod.NearestPostOffice:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Email, {});
    case _models.AddressItemDeliveryMethod.Lpo:
    case _models.AddressItemDeliveryMethod.Spo:
    case _models.AddressItemDeliveryMethod.ParcelLocker:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Pickup, {});
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Oriflame, {});
  }
};
const AddressWrapper = ({
  deliveryFee,
  deliveryMethod,
  isAddressEditable,
  isBoundCourierVisible,
  isDisplayedInMainPage,
  isShippingJoker,
  onEditAddressClick,
  originalDeliveryFee,
  ...address
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const isHomeDelivery = deliveryMethod === _models.AddressItemDeliveryMethod.Home;
  const isShippingOfferVisible = !isDisplayedInMainPage && isShippingJoker && !isBoundCourierVisible;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ...getTestIdProps(_models.TestId.DeliveryBoxAddressWrapper),
    children: [Boolean(isAddressEditable) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditButton.EditButton, {
      onClick: onEditAddressClick
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageWrapper, {
      children: getDeliveryIcon(deliveryMethod)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressInfo.AddressInfo, {
      isDisplayedInMainPage: isDisplayedInMainPage,
      ...address
    }), !isHomeDelivery && /*#__PURE__*/(0, _jsxRuntime.jsxs)(ShippingFeeInfo, {
      children: [isShippingOfferVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShippingOfferTooltip.ShippingOfferTooltip, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(ShippingFeeWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ShippingFee, {
          variant: "body1",
          ...getTestIdProps(_models.TestId.DeliveryBoxFee),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
            children: deliveryFee
          })
        }), Number(originalDeliveryFee) > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(OriginalShippingFee, {
          variant: "caption",
          ...getTestIdProps(_models.TestId.OriginalDeliveryBoxFee),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
            children: Number(originalDeliveryFee)
          })
        }) : null]
      })]
    })]
  });
};
exports.AddressWrapper = AddressWrapper;